export default function AppsWebForm({ form, onChange, onSubmit, onCancel, isEditing, publishers }) {
  const isApp = form.type === "App";
  const isWebsite = form.type === "Website";

  const inputClass = "w-full px-4 py-2.5 border border-gray-200 rounded-xl text-sm bg-white focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent transition-all";
  const selectClass = `${inputClass} text-gray-700`;

  return (
    <form
      onSubmit={onSubmit}
      className="grid grid-cols-1 md:grid-cols-2 gap-5 p-6 w-full max-w-4xl mx-auto"
    >
      {/* Mandatory Fields - First Column */}
      <div className="space-y-6">
        {/* Publisher Dropdown */}
        <div>
          <label htmlFor="publisher" className="block mb-2 text-sm font-medium text-gray-700">
            Publisher *
          </label>
          <select
            id="publisher"
            value={form.publisherId || ""}
            onChange={(e) => onChange({ ...form, publisherId: parseInt(e.target.value) })}
            required
            className={selectClass}
          >
            <option value="">Select Publisher</option>
            {publishers.map((publisher) => (
              <option key={publisher.id} value={publisher.id}>
                {publisher.name}
              </option>
            ))}
          </select>
        </div>

        {/* Type Selector */}
        <div>
          <label htmlFor="type" className="block mb-2 text-sm font-medium text-gray-700">
            Type *
          </label>
          <select
            id="type"
            value={form.type}
            onChange={(e) => onChange({ ...form, type: e.target.value })}
            required
            className={selectClass}
          >
            <option value="">Select Type</option>
            <option value="App">App</option>
            <option value="Website">Website</option>
          </select>
        </div>

        {/* Name - Common for all types */}
        <div>
          <label htmlFor="name" className="block mb-2 text-sm font-medium text-gray-700">
            {isApp ? "App Name *" : isWebsite ? "Website Name *" : "Name *"}
          </label>
          <input
            id="name"
            type="text"
            placeholder={isApp ? "e.g. My App" : isWebsite ? "e.g. My Website" : "Name"}
            value={form.name}
            onChange={(e) => onChange({ ...form, name: e.target.value })}
            required
            className={inputClass}
          />
        </div>

        {/* Status Selector */}
        <div>
          <label htmlFor="status" className="block mb-2 text-sm font-medium text-gray-700">
            Status *
          </label>
          <select
            id="status"
            name="status"
            value={form.status}
            onChange={(e) => onChange({ ...form, status: e.target.value })}
            required
            className={selectClass}
          >
            <option value="On approval">On approval</option>
            <option value="Approved">Approved</option>
            <option value="Rejected">Rejected</option>
          </select>
        </div>
      </div>

      {/* Type-Specific Fields - Second Column */}
      <div className="space-y-6">
        {isApp ? (
          <>
            <div>
              <label htmlFor="platform" className="block mb-2 text-sm font-medium text-gray-700">
                Platform *
              </label>
              <select
                id="platform"
                value={form.platform}
                onChange={(e) => onChange({ ...form, platform: e.target.value })}
                required
                className={selectClass}
              >
                <option value="">Select Platform</option>
                <option value="Android">Android</option>
                <option value="iOS">iOS</option>
              </select>
            </div>
            <div>
              <label htmlFor="appLink" className="block mb-2 text-sm font-medium text-gray-700">
                App Store Link *
              </label>
              <input
                id="appLink"
                type="url"
                placeholder="https://play.google.com/store/apps/…"
                value={form.appLink || ""}
                onChange={(e) => onChange({ ...form, appLink: e.target.value })}
                required
                className={inputClass}
              />
            </div>
            <div>
              <label htmlFor="appId" className="block mb-2 text-sm font-medium text-gray-700">
                App ID/Bundle ID *
              </label>
              <input
                id="appId"
                type="text"
                placeholder="com.example.app"
                value={form.appId || ""}
                onChange={(e) => onChange({ ...form, appId: e.target.value })}
                required
                className={inputClass}
              />
            </div>
          </>
        ) : isWebsite ? (
          <>
            <div>
              <label htmlFor="websiteLink" className="block mb-2 text-sm font-medium text-gray-700">
                Website URL *
              </label>
              <input
                id="websiteLink"
                type="url"
                placeholder="https://www.example.com"
                value={form.websiteLink || ""}
                onChange={(e) => onChange({ ...form, websiteLink: e.target.value })}
                required
                className={inputClass}
              />
            </div>
          </>
        ) : (
          <div className="h-full flex items-center justify-center text-gray-400 bg-gray-50/60 rounded-xl border border-dashed border-gray-200 p-8">
            <p className="text-sm">Select a type to see additional fields</p>
          </div>
        )}
      </div>

      {/* Action Buttons - Full Width */}
      <div className="md:col-span-2 flex justify-end gap-3 pt-4 border-t border-gray-100">
        <button
          type="button"
          onClick={onCancel}
          className="px-5 py-2.5 border border-gray-200 text-gray-700 text-sm font-medium rounded-xl hover:bg-gray-50 transition-colors"
        >
          Cancel
        </button>
        <button
          type="submit"
          className="px-5 py-2.5 bg-gradient-to-r from-indigo-600 to-purple-600 text-white text-sm font-medium rounded-xl hover:brightness-110 hover:shadow-lg transition-all"
        >
          {isEditing ? "Update Property" : "Add Property"}
        </button>
      </div>
    </form>
  );
}